import { useEffect, useState } from "react";
import { CreditCard, LoaderCircle } from "lucide-react";
import { toast } from "sonner";
import { api, errorText, money } from "../../lib/api";
import { loadSnap, paymentConfig, payWithSnap } from "../../lib/midtrans";

const LABELS = {paid: "Pembayaran berhasil. Terima kasih!", pending: "Menunggu penyelesaian pembayaran.", failed: "Pembayaran gagal atau dibatalkan.", closed: "Jendela pembayaran ditutup. Anda dapat melanjutkan kapan saja."};

export const PayButton = ({ order, onPaid, id = `pay-${order.order_id}` }) => {
  const [config, setConfig] = useState(null), [busy, setBusy] = useState(false), [message, setMessage] = useState("");
  useEffect(() => { paymentConfig().then(setConfig); }, []);
  const remaining = (order.total || 0) - (order.paid_amount || 0);
  if (remaining <= 0 || ["Dibatalkan"].includes(order.status)) return null;
  const pay = async () => {
    setBusy(true); setMessage("");
    try {
      const {data} = await api.post(`/payments/orders/${order.order_id}/token`);
      const snap = await loadSnap(config.client_key, config.snap_url);
      const result = await payWithSnap(snap, data.token);
      if (result === "closed") { setMessage(LABELS.closed); return; }
      const status = (await api.get(`/payments/${data.payment_id}/status`)).data;
      setMessage(LABELS[status.status] || LABELS.pending);
      if (status.status === "paid") { toast.success("Pembayaran diterima"); await onPaid?.(); }
    } catch (err) { setMessage(errorText(err)); }
    finally { setBusy(false); }
  };
  if (!config) return null;
  if (!config.enabled) return <p className="muted" data-testid={`${id}-disabled`}>Pembayaran online (Midtrans) belum aktif. Silakan konfirmasi via WhatsApp.</p>;
  return <div className="pay-block" data-testid={`${id}-block`}>
    <button type="button" className="primary" data-testid={`${id}-button`} disabled={busy} onClick={pay}>{busy ? <><LoaderCircle size={16} className="spin"/> Menyiapkan…</> : <><CreditCard size={17}/> Bayar online {money(remaining)}</>}</button>
    {message && <p className="notice" data-testid={`${id}-message`}>{message}</p>}
  </div>;
};
